import { HttpService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

import { Endpoint } from '../constants';

interface AccreditationStatus {
  status:string,
  pendenciesNumber: string,
  revisionsNumber: string
}

class ProviderAccreditationStatusService {
  public static async getAccreditationStatus(nrSeqAccreditation: number, nrSeqProvider: number): Promise<RequestResponse<AccreditationStatus>> {
    return HttpService.get<AccreditationStatus>(Endpoint.GET.ACCREDITATION_STATUS, { nrSeqProvider, nrSeqAccreditation  });
  }
}

export {
  ProviderAccreditationStatusService,
  AccreditationStatus,
};
